/* Generated by scripts/build_survivor_rigs.py. Do not edit by hand. */
export const SURVIVOR_RIG_MANIFEST = {
  "version": 4,
  "atlas": {
    "width": 1024,
    "height": 1024,
    "grid": 4
  },
  "cells": [
    "head",
    "torso",
    "pelvis",
    "bag",
    "upper-left",
    "lower-left",
    "upper-right",
    "lower-right",
    "thigh-left",
    "shin-left",
    "thigh-right",
    "shin-right",
    "hammer",
    "rifle",
    "pouch",
    "radio"
  ],
  "profiles": [
    "mara-voss",
    "jonah-reed",
    "inez-okafor",
    "cal-mercer",
    "dev-malik",
    "ruth-bell",
    "asha-sayeed",
    "leoni-price",
    "gwen-parry",
    "kit-hargreaves",
    "pavel-novak",
    "samira-shah"
  ],
  "renderer": "layered-dom-cutout",
  "bones": [
    {
      "id": "leg-back-upper",
      "parent": "root",
      "frame": "thigh-left",
      "pivot": [
        0.43,
        0.57
      ],
      "drawOrder": 1
    },
    {
      "id": "leg-back-lower",
      "parent": "leg-back-upper",
      "frame": "shin-left",
      "pivot": [
        0.4,
        0.72
      ],
      "drawOrder": 2
    },
    {
      "id": "pelvis",
      "parent": "root",
      "frame": "pelvis",
      "pivot": [
        0.5,
        0.58
      ],
      "drawOrder": 3
    },
    {
      "id": "leg-front-upper",
      "parent": "root",
      "frame": "thigh-right",
      "pivot": [
        0.56,
        0.57
      ],
      "drawOrder": 4
    },
    {
      "id": "leg-front-lower",
      "parent": "leg-front-upper",
      "frame": "shin-right",
      "pivot": [
        0.59,
        0.72
      ],
      "drawOrder": 5
    },
    {
      "id": "arm-back-upper",
      "parent": "torso",
      "frame": "upper-left",
      "pivot": [
        0.37,
        0.25
      ],
      "drawOrder": 6
    },
    {
      "id": "arm-back-lower",
      "parent": "arm-back-upper",
      "frame": "lower-left",
      "pivot": [
        0.31,
        0.4
      ],
      "drawOrder": 7
    },
    {
      "id": "torso",
      "parent": "root",
      "frame": "torso",
      "pivot": [
        0.5,
        0.56
      ],
      "drawOrder": 8
    },
    {
      "id": "head",
      "parent": "torso",
      "frame": "head",
      "pivot": [
        0.5,
        0.23
      ],
      "drawOrder": 9
    },
    {
      "id": "bag",
      "parent": "torso",
      "frame": "bag",
      "pivot": [
        0.61,
        0.32
      ],
      "drawOrder": 10
    },
    {
      "id": "arm-front-upper",
      "parent": "torso",
      "frame": "upper-right",
      "pivot": [
        0.63,
        0.25
      ],
      "drawOrder": 11
    },
    {
      "id": "arm-front-lower",
      "parent": "arm-front-upper",
      "frame": "lower-right",
      "pivot": [
        0.69,
        0.4
      ],
      "drawOrder": 12
    }
  ],
  "props": {
    "hammer": {
      "frame": "hammer",
      "parent": "arm-front-lower"
    },
    "rifle": {
      "frame": "rifle",
      "parent": "arm-front-lower"
    },
    "pouch": {
      "frame": "pouch",
      "parent": "arm-front-lower"
    },
    "radio": {
      "frame": "radio",
      "parent": "arm-front-lower"
    }
  }
} as const;
